import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

    body {
        box-sizing: border-box;
        color: #222;
        font-family: 'Montserrat', sans-serif;
        margin: 0;
        padding: 0;

    }
`;
